// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ListItemCaption-base__JHbce{display:flex;gap:var(--size-2);align-items:center;width:var(--size-full);min-width:0;max-width:-moz-max-content;max-width:max-content}.ListItemCaption-caption__lnY_Y{color:var(--gray-a11);font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400)}.ListItemCaption-warningState__n8Czb .ListItemCaption-caption__lnY_Y{color:var(--amber-a11)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ListItemCaption-base__JHbce",
	"caption": "ListItemCaption-caption__lnY_Y",
	"warningState": "ListItemCaption-warningState__n8Czb"
};
export default ___CSS_LOADER_EXPORT___;
